import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/auditNotice',
  title: window.language["homepage.navBar.auditNotice"],
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/NavBar/AuditNotice/index.js